
import { request } from './request';
import { 
  getRequestConfig, 
} from './config';

export function requestExternalMeasures (formData) {
  const config = getRequestConfig(formData, null, '/data/externalMeasures');
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      resolve(response.data.data);
    })
    .catch( (err) => {
      reject(err);
    });
  });
}
// pass in {}, get back { pageCount: #pages }
// pass in { pageInfo:{page:#pagenumber }}, get back data for that page
export function requestContinuousGlucose (formData) {
  const config = getRequestConfig(formData, null, '/data/getContinuousGlucose');
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      resolve(response.data.data);
    })
    .catch( (err) => {
      reject(err);
    });
  });
}

export function getLatestTime (formData) {
  const config = getRequestConfig(formData, null, '/data/getLatestTime');
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      resolve(response.data.data);
    })
    .catch( (err) => {
      reject(err);
    });
  });
}
